import * as React from 'react';
import { Layout, Menu, Icon } from 'antd';
import logo from './logo.png';
import SubMenu from 'antd/lib/menu/SubMenu';

const { Sider } = Layout;

interface P {
  onMenuClick?: (item: { key: string }) => void;
}

export default class SideNav extends React.Component<P> {
  render() {
    const { onMenuClick } = this.props;

    return (
      <Sider
        className="side-nav"
        collapsible={true}
        defaultCollapsed={true}
        style={{ backgroundColor: '#2d373c', color: '#222' }}
      >
        <div className="logo">
          <img alt={'logo'} src={logo} />
          <h2>DataFocus</h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['dashboards']}
          onClick={onMenuClick}
        >
          <SubMenu key="dashboards" title={<span><Icon type="home" /><span>Dashboard</span></span>}>
            <Menu.Item key="dashboards/merchantStatus">
              <Icon type="bar-chart" />
              <span>Merchant Status</span>
            </Menu.Item>
            <Menu.Item key="dashboards/merchantDetail">
              <Icon type="line-chart" />
              <span>Merchant Detial</span>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="setting" title={<span><Icon type="setting" /><span>Setting</span></span>}>
            <Menu.Item key="categories">
              <Icon type="database" />
              <span>Categories</span>
            </Menu.Item>
            <Menu.Item key="featuredCategories">
              <Icon type="picture" />
              <span>Featured Categories</span>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="carousel" title={<span><Icon type="pic-center" /><span>Carousel</span></span>}>
            <Menu.Item key="featuredAds">
              <Icon type="picture" />
              <span>Featured Ads</span>
            </Menu.Item>

            <Menu.Item key="trendingCategories">
              <Icon type="picture" />
              <span>Trending Categories</span>
            </Menu.Item>
          </SubMenu>
          <Menu.SubMenu title={<span><Icon type="team" /> <span>Member</span></span>}>
            <Menu.Item key="members">
              <span>Members</span>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu title={<span><Icon type="shop" /> <span>Merchant</span></span>}>
            <Menu.Item key="merchants">
              <span>Merchants</span>
            </Menu.Item>
          </Menu.SubMenu>
          {/* <Menu.Item key="tools">
            <Icon type="tool" />
            <span>Tools</span>
          </Menu.Item> */}
        </Menu>
      </Sider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/SideNav.tsx